import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import slugify from 'slugify';

//import comps
import Hero from '../components/Hero';
import Edges from '../components/Edges';

import { useStore } from '../store';
import * as theme from '../theme';

//import MUI
import BusinessIcon from '@mui/icons-material/WorkOutlineOutlined';
import ComputerIcon from '@mui/icons-material/ComputerOutlined';
import EnergyIcon from '@mui/icons-material/OfflineBoltOutlined';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import SchoolIcon from '@mui/icons-material/School';

const IndexPage = () => {
    const [{ appState: { schools } }] = useStore() as any;

    /*
     * Render's a icon based on schoolName. schoolName is safer as id's are more likely to change then school names.
     */
    const renderSchoolIcon = (schoolName) => {

        if (schoolName === 'Business') {
            return <BusinessIcon />;
        } else if (schoolName === 'Computing and Academic') {
            return <ComputerIcon />;
        } else if (schoolName === 'Energy') {
            return <EnergyIcon />;
        } else if (schoolName.includes('Health')) {
            return <LocalHospitalIcon />;
        } else if (schoolName.includes('Construction')) {
            return <ConstructionIcon
                width="23"
                height="33"
                viewBox="0 0 66 76"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M19.1131 6.234L19.2838 6.41663L19.1131 6.23401C15.7266 9.39988 13.5368 13.5747 12.8509 18.1183C5.55312 21.3767 0.75 28.7058 0.75 36.8141C0.75 48.093 9.89149 57.2701 21.1302 57.2701C24.4513 57.2701 27.6914 56.4574 30.5871 54.934V72.9423C30.5871 74.275 31.6674 75.3553 33 75.3553C34.3326 75.3553 35.4129 74.275 35.4129 72.9424V54.934C38.3086 56.4574 41.5487 57.2701 44.8698 57.2701C56.1087 57.2701 65.25 48.0929 65.25 36.8141C65.2504 28.7058 60.4473 21.3765 53.1495 18.1183C52.4638 13.5747 50.2739 9.39987 46.8873 6.23401L46.7166 6.41663L46.8873 6.234C43.1046 2.69784 38.1724 0.75 33.0003 0.75C27.8282 0.75 22.896 2.69784 19.1131 6.234ZM17.2201 21.6322L17.3729 21.5775L17.3851 21.4157L17.4909 20.0094C17.4909 20.0094 17.4909 20.0094 17.4909 20.0094C17.7858 16.0963 19.53 12.4625 22.4029 9.77681L22.2322 9.59418L22.4029 9.77681C25.2897 7.07801 29.053 5.59211 33.0003 5.59211C36.9476 5.59211 40.7109 7.07801 43.5978 9.77667C46.4708 12.4624 48.2149 16.096 48.5098 20.0093L48.6157 21.4155L48.6278 21.5773L48.7806 21.6321L50.1037 22.1065C56.2762 24.3201 60.4246 30.2305 60.4246 36.814C60.4246 45.4242 53.4458 52.428 44.8701 52.428C41.4378 52.428 38.1189 51.2913 35.4132 49.2089V36.2025L43.0685 32.1622C44.2476 31.5399 44.701 30.081 44.0824 28.9C43.461 27.7139 41.9943 27.2581 40.8101 27.8831L35.4132 30.7315V24.762C35.4132 23.4294 34.3329 22.3491 33.0003 22.3491C31.6677 22.3491 30.5874 23.4294 30.5874 24.762V40.3554L25.1905 37.5071C24.0062 36.8821 22.5396 37.3379 21.9182 38.524C21.2995 39.705 21.7529 41.1639 22.932 41.7862L30.5874 45.8265V49.2089C27.8817 51.2913 24.5628 52.428 21.1305 52.428C12.5548 52.428 5.57611 45.4242 5.57611 36.8141C5.57611 30.2307 9.72457 24.3202 15.897 22.1067L17.2201 21.6322Z"
                    fill="#234169"
                    stroke="#003E6B"
                />
            </ConstructionIcon>;
        } else {
            return <SchoolIcon />;
        }
    };

    return (
        <>
            <Hero />
            <Edges size="md" style={{ padding: '0 0 40px 0' }}>
                <SchoolContainer>
                    <h3>BCIT SCHOOLS</h3>
                    <Items>
                        {schools &&
                            schools.map((s) => {
                                const slug = slugify(s.schoolName, {
                                    replacement: '-',
                                    lower: true
                                });
                                return (
                                    <Item key={s.schoolID} to={`/${slug}`}>
                                        {renderSchoolIcon(s.schoolName)}
                                        <h3 children={s.schoolName} />
                                    </Item>
                                );
                            })}
                    </Items>
                </SchoolContainer>


                {/* Booking Office Hours */}
                {/* TODO: Waiting for approval to display booking office hours info */}
                {/* <BookingContainer>
                    <BookingTitle>
                        <h3>BOOKING OFFICE HOURS</h3>
                        <NewIcon>NEW</NewIcon>
                    </BookingTitle>
                    <BookingInfo>
                        <h4>
                            Did you know that you can now book office hours in three simple steps?
                        </h4>
                        <List>
                            <li>
                                Select your school and the instructor you would like to book an
                                appointment with
                            </li>
                            <li>
                                Click “Book Office Hours” above the instructors schedule if
                                available
                            </li>
                            <li>
                                Select your preferred date and time slot, fill out your information,
                                and confirm your booking
                            </li>
                        </List>
                    </BookingInfo>
                </BookingContainer> */}
            </Edges>
        </>
    );
};

const SchoolContainer = styled.div`
    margin-bottom: 3em;
`;
const BookingContainer = styled.div`
    margin-bottom: 3em;
    display: flex;
    flex-direction: column;
`;
const BookingInfo = styled.div`
    background-color: #fff;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 15px;

    h4 {
        margin: 10px 0 0 20px;
    }
`;
const BookingTitle = styled.div`
    display: flex;
    align-items: center;
`;
const List = styled.ol`
    li {
        padding: 10px 0 10px 0;

        &:last-of-type {
            padding: 10px 0 0 0;
        }
    }
`;

const NewIcon = styled.div`
    background-color: ${theme.colors.active};
    border-radius: 75px;
    width: 60px;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-weight: 600;
    margin-left: 1em;
    font-size: 14px;
`;

//delete margin right when there are more than two schools
const Items = styled.div`
    display: flex;
    flex-wrap: wrap;
`;
const ConstructionIcon = styled.svg`
    position: relative;
    left: 0px;
    @media (min-width: 800px) {
        left: 25px;
    }
`;


const Item = styled(Link)`
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: #fff;
    color: #21406a;
    box-shadow: 0 5px 12px 1px rgba(0, 0, 0, 0.08);
    text-decoration: none;
    padding: 20px;
    transition: ease all 0.2s;
    margin-bottom: 20px;
    margin-top: 0px;
    border-radius: 5px;

    @media (min-width: 640px) {
        width: calc(33.3333% - 15px);
        height: 130px;
        margin-right: 15px;
    }

    h3 {
        margin: 0;
        color: #21406a;
        padding: 0 0 0 12px;
        @media (min-width: 640px) {
            padding: 0 0 0 8px;
        }
    }

    &:hover {
        background: #005fa5;
        box-shadow: 0 5px 10px 1px rgba(0, 0, 0, 0.4);

        svg {
            path {
                fill: #fff;
            }
        }

        * {
            color: #fff;
        }
    }
`;

export default IndexPage;
